var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8105 1.44043L14.4551 12.6553C14.2793 13.4287 13.7871 13.6396 13.1191 13.2529L9.49805 10.5811L7.77539 12.2686C7.56445 12.4795 7.42383 12.6201 7.03711 12.6201L7.2832 8.92871L13.998 2.88184C14.3145 2.63574 13.9277 2.45996 13.541 2.74121L5.24414 7.94434L1.69336 6.85449C0.919922 6.6084 0.884766 6.08105 1.83398 5.69434L15.8262 0.31543C16.459 0.0693359 17.0215 0.456055 16.8105 1.44043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.84cf7e39800adc208da78c5427e77ebe.svg";
export { ForwardRef as ReactComponent };